import { render, staticRenderFns } from "./ListarDevedor.vue?vue&type=template&id=b634a28a&"
import script from "./ListarDevedor.vue?vue&type=script&lang=js&"
export * from "./ListarDevedor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports